
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitojaipurcab() {



    const cardData =
    {
        keyword: ' Mumbai to Jaipur Cab   ',
        heading: 'Deva Cabs: Mumbai to Jaipur Cab   ',
        headingDescription: 'Deva Cabs delivers premium and comfortable cab services from Mumbai to Jaipur, perfect for leisure travel, family vacations, and business trips. Journeying approximately 1,150 km, our well-maintained fleet—Sedans, SUVs, and Innova Crysta—ensures a smooth and relaxing long-distance ride through scenic landscapes. Travel with confidence alongside our experienced drivers, benefit from fixed fare packages, and enjoy door-to-door pickup service. With 24/7 availability and transparent pricing, Deva Cabs makes your Mumbai to Jaipur cab journey stress-free, enjoyable, and truly memorable.',

        top: 'Top Places to Visit in Jaipur with Deva Cabs',

"topPlaces": [
  {
    "title": "Amer Fort (Amber Palace)",
    "location": "Amber, Jaipur, Rajasthan",
    "description": "A majestic hilltop fortress built in 1592 by Raja Man Singh I, Amer Fort combines Rajput and Mughal architectural styles. Highlights include the mirrored Sheesh Mahal, ornate Ganesh Gate, and stunning views over Maota Lake. A must-see UNESCO‑listed complex :contentReference[oaicite:1]{index=1}."
  },
  {
    "title": "Hawa Mahal",
    "location": "Badi Chaupar, Jaipur, Rajasthan",
    "description": "Also known as the 'Palace of Winds', this five‑storey pink sandstone facade built in 1799 features 953 intricately carved windows (jharokhas) enabling royal women to observe street life unseen. Its honeycomb structure also provides natural cooling :contentReference[oaicite:2]{index=2}."
  },
  {
    "title": "City Palace",
    "location": "Chandpole, Jaipur, Rajasthan",
    "description": "The royal residence of Jaipur’s rulers, built between 1729–1732 by Maharaja Jai Singh II. This sprawling complex includes Mubarak Mahal, Chandra Mahal, Diwan‑e‑Aam/Khas, Shri Govind Dev Ji Temple, and a museum showcasing royal artifacts :contentReference[oaicite:3]{index=3}."
  },
  {
    "title": "Jantar Mantar",
    "location": "Near City Palace, Jaipur, Rajasthan",
    "description": "A UNESCO World Heritage astronomical observatory built 1728–1734 by Sawai Jai Singh II, featuring 19 stone instruments—including the world’s largest sundial—for tracking celestial bodies with the naked eye :contentReference[oaicite:4]{index=4}."
  },
  {
    "title": "Nahargarh Fort",
    "location": "On the Aravalli Hills, Jaipur, Rajasthan",
    "description": "Overlooking the Pink City since 1734, Nahargarh (‘Abode of Tigers’) Fort offers panoramic sunrise and sunset views. Once a retreat for royalty, it connects to Amer and Jaigarh forts and features historic Madhavendra Bhawan :contentReference[oaicite:5]{index=5}."
  },
  {
    "title": "Jal Mahal",
    "location": "Man Sagar Lake, Jaipur, Rajasthan",
    "description": "The ‘Water Palace’, built c. 1699 and later expanded, sits partly submerged in Man Sagar Lake. Its light-colored façade against the serene water makes it a scenic—and iconic—spot for photography, especially at sunset :contentReference[oaicite:6]{index=6}."
  },
  {
    "title": "Albert Hall Museum",
    "location": "Ram Niwas Garden, Jaipur, Rajasthan",
    "description": "Also known as the Government Central Museum, this Indo‑Sarcenic building hosts art, sculptures, textiles, and the Dolls Museum. A prime example of royal‑era culture and creativity :contentReference[oaicite:7]{index=7}."
  },
  {
    "title": "Birla Mandir (Lakshmi Narayan Temple)",
    "location": "Mandir Marg, Jaipur, Rajasthan",
    "description": "A white marble temple dedicated to Lord Vishnu and Goddess Lakshmi, built in modern architectural style. It’s beautifully illuminated at night and set atop a small hill encircled by lush gardens :contentReference[oaicite:8]{index=8}."
  },
  {
    "title": "Patrika Gate & Jawahar Circle Garden",
    "location": "Jawahar Circle, Jaipur, Rajasthan",
    "description": "A vibrant landmark featuring colorful Rajasthani murals and intricate fractal‑like architecture at the entrance to Jawahar Circle Park—the largest circular park in Asia with floral displays and musical fountains :contentReference[oaicite:9]{index=9}."
  },
  {
    "title": "Jaigarh Fort",
    "location": "Above Amer Fort, Jaipur, Rajasthan",
    "description": "A robust fortress built in the early 18th century to protect Amer and house royal armaments. Known for its cannon ‘Jaivana’—once the world’s largest—it connects to Amer Fort via subterranean passages :contentReference[oaicite:10]{index=10}."
  }
],



  "services": [
    {
      "name": "Mumbai to Jaipur Cab",
      "description": "Experience a comfortable and hassle-free journey from Mumbai to Jaipur with our reliable cab services. Whether traveling for business, leisure, or family visits, our well-maintained fleet ensures you reach your destination safely and on time. Choose from a variety of vehicles including sedans, SUVs, and luxury cars, all driven by professional chauffeurs committed to excellent service. Book online for convenience and enjoy competitive pricing with round-the-clock customer support."
    },
    {
      "name": "Long distance cab Mumbai to Jaipur",
      "description": "Cover the long distance between Mumbai and Jaipur effortlessly with our specialized long-distance cab service. Our vehicles are equipped for extended travel, providing ample space, comfort, and air conditioning for a pleasant ride. Professional drivers with thorough knowledge of the route ensure a smooth and timely journey. Ideal for travelers seeking safe, stress-free transportation across states."
    },
    {
      "name": "Book cab Mumbai to Jaipur online",
      "description": "Reserve your Mumbai to Jaipur cab quickly and easily through our user-friendly online booking platform. Get instant confirmation, transparent pricing, and a wide range of vehicle options tailored to your needs. Our seamless booking experience lets you plan your trip in advance, ensuring peace of mind and reliable service from pickup to drop."
    },
    {
      "name": "One-way Mumbai to Jaipur taxi",
      "description": "For travelers who need a direct trip from Mumbai to Jaipur, our one-way taxi service offers flexible scheduling, competitive rates, and a variety of vehicle types including AC cars and SUVs. Perfect for quick business trips or personal visits, this service provides door-to-door convenience with professional chauffeurs ensuring safety and comfort."
    },
    {
      "name": "Round trip Jaipur cab from Mumbai",
      "description": "Plan your round trip from Mumbai to Jaipur with ease using our dedicated cab service. Enjoy the convenience of a single booking for both onward and return journeys, with options to customize stops and schedules according to your itinerary. Our experienced drivers and quality vehicles make your entire trip comfortable and stress-free."
    },
    {
      "name": "Chauffeur-driven cab Mumbai to Jaipur",
      "description": "Travel in style and comfort with our chauffeur-driven cab services from Mumbai to Jaipur. Our skilled drivers prioritize safety, punctuality, and excellent customer service, allowing you to relax or focus on your work during the journey. Choose from luxury sedans, SUVs, or standard AC cabs to suit your preferences and group size."
    },
    {
      "name": "AC taxi Mumbai to Jaipur",
      "description": "Beat the heat with our air-conditioned taxi service from Mumbai to Jaipur. All vehicles are equipped with modern AC systems to ensure a cool and comfortable ride throughout the long-distance journey. Ideal for family trips, corporate travel, or leisure visits, our AC taxis combine comfort with affordability."
    },
    {
      "name": "SUV cab Mumbai to Jaipur",
      "description": "Travel with extra space and comfort in our SUV cabs from Mumbai to Jaipur. Perfect for families or groups with luggage, our SUVs provide a smooth ride with powerful performance on highways. Equipped with AC and modern amenities, these vehicles are ideal for long-distance travel ensuring a pleasant journey."
    },
    {
      "name": "Affordable Jaipur cab Mumbai",
      "description": "Get the best value for your money with our affordable cab services from Mumbai to Jaipur. We offer competitive rates without compromising on quality, safety, or comfort. Choose from economy to premium vehicles and enjoy a reliable service tailored to your budget."
    },
    {
      "name": "Premium cab Mumbai to Jaipur",
      "description": "Indulge in luxury with our premium cab services from Mumbai to Jaipur. Featuring high-end cars with plush interiors, advanced features, and professional chauffeurs, this service is perfect for executives, VIPs, or special occasions. Enjoy a superior travel experience with personalized service and utmost convenience."
    }
  ],
  "tableData": [
    ["Mumbai to Jaipur Cab", "-Long distance cab Mumbai to Jaipur"],
    ["Book cab Mumbai to Jaipur online", "-One-way Mumbai to Jaipur taxi"],
    ["Round trip Jaipur cab from Mumbai", "-Chauffeur-driven cab Mumbai to Jaipur"],
    ["AC taxi Mumbai to Jaipur", "-SUV cab Mumbai to Jaipur"],
    ["Affordable Jaipur cab Mumbai", "-Premium cab Mumbai to Jaipur"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Jaipur Cab Service",
    "WhyChoosedescription": "Embark on a comfortable and dependable journey from Mumbai to the Pink City, Jaipur. Whether traveling for leisure, business, or family visits, our cab service ensures punctual pickups, smooth rides, and a hassle-free experience over the approximately 1,150 km route. Trust us to provide timely and professional service throughout your trip."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Long-Distance Travel",
    "WhyChoosedescription": "Our well-maintained, air-conditioned fleet includes sedans, SUVs, and larger vehicles, all designed for maximum comfort and ample luggage space. Relax in ergonomic seating and enjoy amenities that make the long journey from Mumbai to Jaipur as enjoyable as your destination."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Jaipur Route",
    "WhyChoosedescription": "Our professional drivers have extensive experience navigating the highways and routes connecting Mumbai and Jaipur. They prioritize safety, punctuality, and passenger comfort, skillfully handling road conditions and traffic to ensure a secure and stress-free journey."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer upfront pricing with no hidden fees, covering tolls, fuel, and driver allowances. Our competitive rates allow you to budget your trip confidently, making our Mumbai to Jaipur cab service both affordable and reliable."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Our cab service is available round the clock to accommodate your preferred travel times. Whether you want to start early morning or late at night, we provide the flexibility needed for a seamless travel experience."
  },
  {
    "WhyChooseheading": "Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to Jaipur cab is quick and convenient through our website or customer support. Receive instant confirmation along with detailed fare and driver information, giving you peace of mind as you plan your journey."
  },
  {
    "WhyChooseheading": "Safety and Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles in our fleet undergo regular maintenance and sanitization to ensure safety and hygiene. Equipped with seat belts, GPS tracking, and emergency kits, our cabs provide a secure environment for long-distance travel."
  },
  {
    "WhyChooseheading": "Customizable Travel Packages to Suit Your Itinerary",
    "WhyChoosedescription": "We offer flexible travel options including one-way trips, round trips, and multi-day plans with stops along the route. Whether traveling solo, with family, or in a group, we tailor our services to meet your specific travel needs and preferences."
  }
]















    }








const faqData = [
  {
    question: "Can I book a cab from Mumbai to Jaipur with Deva Cabs?",
    answer: "Yes, Deva Cabs offers comfortable and reliable cab services from Mumbai to Jaipur for leisure, business, and group travel."
  },
  {
    question: "How long does the journey from Mumbai to Jaipur take by cab?",
    answer: "The trip usually takes around 15 to 17 hours depending on traffic and route."
  },
  {
    question: "What types of vehicles are available for the Mumbai to Jaipur route?",
    answer: "We provide a range of vehicles including sedans, SUVs, Innova Crysta, Ertiga, and tempo travellers to accommodate various group sizes."
  },
  {
    question: "Can I book a one-way or round-trip cab from Mumbai to Jaipur?",
    answer: "Yes, Deva Cabs offers both one-way and round-trip cab services tailored to your travel plans."
  },
  {
    question: "Are tolls, parking, and driver charges included in the fare?",
    answer: "Additional charges such as tolls, parking, and driver allowances are generally extra and will be communicated upfront."
  },
  {
    question: "Is the Mumbai to Jaipur cab service available 24/7?",
    answer: "Yes, Deva Cabs operates 24/7 to ensure you can book a ride at any preferred time."
  },
  {
    question: "Is it safe to travel long distances with Deva Cabs?",
    answer: "Absolutely. Our drivers are experienced, background-verified, and trained for long-distance journeys."
  },
  {
    question: "Can I customize my trip with stops or sightseeing on the way to Jaipur?",
    answer: "Yes, customized itineraries with stops and sightseeing can be arranged upon request."
  },
  {
    question: "Is this service suitable for families and groups?",
    answer: "Yes, we have vehicles suitable for families and groups of all sizes to ensure a comfortable journey."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Jaipur cab service?",
    answer: "Deva Cabs offers professional drivers, clean vehicles, transparent pricing, and dependable service for a hassle-free travel experience."
  }
];

const testimonialData = [
  {
    id: 59,
    name: 'Mr. Vikram Singh',
    role: 'Traveler',
    review: 'Our Mumbai to Jaipur cab ride with Deva Cabs was smooth and comfortable. The driver was courteous and punctual.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 60,
    name: 'Ms. Sneha Verma',
    role: 'Family Traveler',
    review: 'Deva Cabs made our long-distance journey from Mumbai to Jaipur hassle-free and enjoyable. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jaipur Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-jaipur-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Jaipur cab with Deva Cabs. One-way and round-trip intercity taxi service with AC, SUV, premium, and chauffeur-driven cab options. Affordable and comfortable for long-distance travel.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "694"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "14300",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-jaipur-cab" // Replace with actual page URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Jaipur Cab | One-Way & Round Trip Taxi | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Jaipur cab online with Deva Cabs. Affordable and comfortable long-distance taxi options including AC, SUV, premium and chauffeur-driven cars for one-way or round trip." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Jaipur Cab, Long distance cab Mumbai to Jaipur, Book cab Mumbai to Jaipur online, One-way Mumbai to Jaipur taxi, Round trip Jaipur cab from Mumbai, Chauffeur-driven cab Mumbai to Jaipur, AC taxi Mumbai to Jaipur, SUV cab Mumbai to Jaipur, Affordable Jaipur cab Mumbai, Premium cab Mumbai to Jaipur" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitojaipurcab;